/**
 * Defaults para Formularios
 */

export const formDefaults: Record<string, Record<string, unknown> | undefined> = {
  VTextField: {
    variant: 'outlined',
    color: 'primary',
    density: 'comfortable',
    rounded: 'lg',
  },

  VSelect: {
    variant: 'outlined',
    color: 'primary',
    density: 'comfortable',
    rounded: 'lg',
  },

  VCombobox: {
    variant: 'outlined',
    color: 'primary',
    density: 'comfortable',
    rounded: 'lg',
  },

  VAutocomplete: {
    variant: 'outlined',
    color: 'primary',
    density: 'comfortable',
    rounded: 'lg',
  },

  VTextarea: {
    variant: 'outlined',
    color: 'primary',
    density: 'comfortable',
    rounded: 'lg',
  },

  VCheckbox: {
    color: 'primary',
    density: 'comfortable',
  },

  VRadio: {
    color: 'primary',
    density: 'comfortable',
  },

  VRadioGroup: {
    color: 'primary',
    density: 'comfortable',
  },

  VSwitch: {
    color: 'primary',
    density: 'comfortable',
    inset: true,
  },

  VSlider: {
    color: 'primary',
    thumbLabel: true,
  },

  VRangeSlider: {
    color: 'primary',
    thumbLabel: true,
  },

  VFileInput: {
    variant: 'outlined',
    color: 'primary',
    density: 'comfortable',
    rounded: 'lg',
    prependIcon: 'mdi-paperclip',
  },
}
